import { Modal, Tooltip } from 'antd';
import { useMemo, useState } from 'react';
import { AnimatePresence } from 'framer-motion';

//ASSETS
// import area from '../../../../../../assets/img/card_area.svg';
// import execucoes from '../../../../../../assets/img/card_execucao.svg';
import finalizados from '../../../../../../assets/img/card_talhao.svg';
import unusual from '../../../../../../assets/img/card_unusual.svg';
import vazios from '../../../../../../assets/img/card_vazio.svg';

//STYLES
import { Detalhes } from "./style";

//APP
import { talhoesFinalizados } from '../../meta/dados_modais';
import { transition_default } from '../../../../../../utils';
import { Item__EquipeCliente } from '../../../../../../services/Equipe/GET';
import { Item__Atividades, ItemPropriedades } from '../../../../../../services/atividades/GET';
import { atividadesSemTalhao, talhoesForaDoComum } from './meta';

//COMPONENTS
import { Execucoes } from '../modais/execucoes';
import { TalhoesCard } from '../modais/talhoes';
import { CardDetalhe } from "./components/card";
import { ForaDoComum } from '../modais/foraDoComum';
import { SemAtividade } from '../modais/semAtividade';
import { TalhoesPlanejadas } from '../modais/planejadas';
import { TalhoesFinalizados } from '../modais/talhoesFinalizados';
import { DefaultTitle } from '../defaultTitle';

//CONST
const segmento_permitido = ['', 'Todos', 'Atividades'];

//PROPS
interface Props {
    dados_detalhamento: {
        talhoes_finalizados: number,
        qtd_talhoes: number,
        qtd_execucoes: number,
        qtd_planejadas: number,
        area_concluida: string,
        area_total: string
    };
    todas_atividades_ativas: Item__Atividades[];
    data_equipe_cliente: Item__EquipeCliente[];
    data_propriedades: ItemPropriedades[];
    cod_propriedade_selecionada: number;
    cod_talhao_selecionado: number;
    cod_subarea_selecionada: number;
    segmento: string;
}


export const Detalhamento: React.FC<Props> = ({ dados_detalhamento, todas_atividades_ativas, data_equipe_cliente, data_propriedades, cod_propriedade_selecionada, cod_talhao_selecionado, segmento, cod_subarea_selecionada }) => {

    //MODAIS
    const [open_talhoes, setOpen_talhoes] = useState<boolean>(false);
    const [open_talhoes_finalizados, setOpen_talhoes_finalizados] = useState<boolean>(false);
    const [open_execucoes, setOpen_execucoes] = useState<boolean>(false);
    const [open_planejadas, setOpen_planejadas] = useState<boolean>(false);
    const [open_fora_do_comum, setOpen_fora_do_comum] = useState<boolean>(false);
    const [open_sem_atividade, setOpen_sem_atividade] = useState<boolean>(false);

    // const tooltip_area_totaol = `Soma das áreas de todos os talhões`;

    const th_unusual = useMemo(() => talhoesForaDoComum(todas_atividades_ativas, data_propriedades, cod_propriedade_selecionada, cod_talhao_selecionado, cod_subarea_selecionada).qtd, [todas_atividades_ativas, data_propriedades, cod_propriedade_selecionada, cod_talhao_selecionado, cod_subarea_selecionada]);
    const th_sem_atividade = useMemo(() => atividadesSemTalhao(todas_atividades_ativas, data_propriedades, cod_propriedade_selecionada, cod_talhao_selecionado).qtd, [todas_atividades_ativas, data_propriedades, cod_propriedade_selecionada, cod_talhao_selecionado]);

    const detalhes: Array<{ title: string; value: number; icon: string; type: string; tooltip?: string; titleSize: number; onClick?: () => void; color: 'default' | 'red' | 'yellow' | 'green', }> = [
        { title: 'Qtde de Talhões e subáreas', value: dados_detalhamento?.qtd_talhoes, icon: '', type: 'number', titleSize: 12, onClick: () => setOpen_talhoes(true), color: 'default', tooltip: 'Quantidade de talhões e subáreas' },
        { title: 'Atividades planejadas', value: dados_detalhamento?.qtd_planejadas, icon: '', type: 'number', titleSize: 10.5, onClick: () => setOpen_planejadas(true), color: 'default', tooltip: 'Atividades planejadas distintas pelo título da operação' },
        { title: 'Execuções', value: dados_detalhamento?.qtd_execucoes, icon: '', type: 'number', titleSize: 12, onClick: () => setOpen_execucoes(true), color: 'default', tooltip: 'Quantidade de execuções' },
        { title: 'Talhões sem atividade', value: th_sem_atividade, icon: vazios, type: 'number', titleSize: 12, onClick: () => setOpen_sem_atividade(true), color: 'red', tooltip: 'Talhões sem nenhuma atividade planejada' },
        { title: 'Fora do comum', value: th_unusual, icon: unusual, type: 'number', titleSize: 12, onClick: () => setOpen_fora_do_comum(true), color: 'yellow', tooltip: 'Talhões com pelo menos 50% a mais ou a menos de atividades que a média' },
        { title: 'Talhões finalizados', value: dados_detalhamento?.talhoes_finalizados, icon: finalizados, type: 'number', titleSize: 12, onClick: () => setOpen_talhoes_finalizados(true), color: 'green', tooltip: 'Talhões cujas atividades estão todas concluídas' },
        // { title: 'Área Total', value: `${dados_detalhamento?.area_total} ha`, icon: '', type: 'area', titleSize: 12, tooltip: tooltip_area_totaol, color: 'default' }
    ];

    return (
        <AnimatePresence>
            {segmento_permitido.includes(segmento) && (
                <Detalhes
                    layout
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ y: 90, opacity: 0, transition: { delay: 0, ease: [0, 0.71, 0.2, 1.01] } }}
                    transition={{ ...transition_default, delay: 0.8 }}
                    data-segmento={segmento}
                    key={'detalhamento'}
                >
                    <DefaultTitle title="Detalhamento" />

                    <div className="Detalhamento__cards">
                        {(detalhes ?? []).map(({ title, value, type, icon, titleSize, tooltip, onClick, color }, i) => {
                            return (
                                <Tooltip key={title + i} title={tooltip}>
                                    <samp key={title + i + 'samp'}>
                                        <CardDetalhe
                                            title={title}
                                            value={value}
                                            type={type}
                                            icon={icon}
                                            title_size={titleSize}
                                            onClick={onClick}
                                            color={color as 'default' | 'red' | 'yellow' | 'green'}
                                        />
                                    </samp>
                                </Tooltip>
                            )
                        })}
                    </div>






                    <Modal
                        open={open_talhoes}
                        onCancel={() => { setOpen_talhoes(false) }}
                        title="Talhões"
                        footer={false}
                        width={960}
                        destroyOnClose
                    >
                        <TalhoesCard
                            data_equipe_cliente={data_equipe_cliente}
                            lista_talhoes_finalizados={talhoesFinalizados(todas_atividades_ativas, data_propriedades).talhoes}
                            cod_propriedade_selecionada={cod_propriedade_selecionada}
                            cod_talhao_selecionado={cod_talhao_selecionado}
                            cod_subarea_selecionada={cod_subarea_selecionada}
                        />
                    </Modal>

                    <Modal
                        open={open_talhoes_finalizados}
                        onCancel={() => { setOpen_talhoes_finalizados(false) }}
                        title="Talhões finalizados"
                        footer={false}
                        width={960}
                        destroyOnClose
                    >
                        <TalhoesFinalizados
                            data_equipe_cliente={data_equipe_cliente}
                            lista_talhoes_finalizados={talhoesFinalizados(todas_atividades_ativas, data_propriedades).finalizados}
                        />
                    </Modal>

                    <Modal
                        open={open_execucoes}
                        onCancel={() => { setOpen_execucoes(false) }}
                        title="Execuções"
                        footer={false}
                        width={960}
                        destroyOnClose
                    >
                        <Execucoes
                            data_equipe_cliente={data_equipe_cliente}
                            lista_talhoes_finalizados={talhoesFinalizados(todas_atividades_ativas, data_propriedades).talhoes}
                        />
                    </Modal>

                    <Modal
                        open={open_planejadas}
                        onCancel={() => { setOpen_planejadas(false) }}
                        title="Atividades planejadas"
                        footer={false}
                        width={960}
                        destroyOnClose
                    >
                        <TalhoesPlanejadas
                            data_equipe_cliente={data_equipe_cliente}
                            lista_talhoes_finalizados={talhoesFinalizados(todas_atividades_ativas, data_propriedades).talhoes}
                            cod_propriedade_selecionada={cod_propriedade_selecionada}
                            cod_talhao_selecionado={cod_talhao_selecionado}
                        />
                    </Modal>

                    <Modal
                        open={open_fora_do_comum}
                        onCancel={() => { setOpen_fora_do_comum(false) }}
                        title="Fora do comum"
                        footer={false}
                        width={960}
                        destroyOnClose
                    >
                        <ForaDoComum
                            lista_talhoes={talhoesForaDoComum(todas_atividades_ativas, data_propriedades, cod_propriedade_selecionada, cod_talhao_selecionado, cod_subarea_selecionada)?.lista_talhoes ?? []}
                            data_equipe_cliente={data_equipe_cliente}
                            media_atvs={talhoesForaDoComum(todas_atividades_ativas, data_propriedades, cod_propriedade_selecionada, cod_talhao_selecionado, cod_subarea_selecionada)?.media_atvs ?? 0}
                        />
                    </Modal>

                    <Modal
                        open={open_sem_atividade}
                        onCancel={() => { setOpen_sem_atividade(false) }}
                        title="Talhões sem atividade"
                        footer={false}
                        width={960}
                        destroyOnClose
                    >
                        <SemAtividade
                            lista_talhoes={atividadesSemTalhao(todas_atividades_ativas, data_propriedades, cod_propriedade_selecionada, cod_talhao_selecionado)?.lista_talhoes ?? []}
                            data_propriedades={data_propriedades}
                        />
                    </Modal>
                </Detalhes>
            )}
        </AnimatePresence>
    )
}